import type React from 'react';
import type { VoiceMessages } from '../config/voiceMessages';

export type ActiveChatTab = 'chat' | 'voice';

type ChatVoiceTabBarProps = {
  activeTab: ActiveChatTab;
  onTabChange: (tab: ActiveChatTab) => void;
  // Used to colour the active-tab indicator to match the widget's theme
  activeColor: string;
  // Resolved for the language configured on the widget's voice config
  messages: VoiceMessages;
};

const ChatVoiceTabBar: React.FC<ChatVoiceTabBarProps> = ({
  activeTab,
  onTabChange,
  activeColor,
  messages,
}) => {
  return (
    <div className='chat-voice-tab-bar'>
      <button
        type='button'
        className={`chat-voice-tab${activeTab === 'chat' ? ' chat-voice-tab--active' : ''}`}
        style={
          activeTab === 'chat'
            ? { color: activeColor, borderTopColor: activeColor }
            : {}
        }
        onClick={() => {
          onTabChange('chat');
        }}>
        {messages.tabs.chat}
      </button>
      <button
        type='button'
        className={`chat-voice-tab${activeTab === 'voice' ? ' chat-voice-tab--active' : ''}`}
        style={
          activeTab === 'voice'
            ? { color: activeColor, borderTopColor: activeColor }
            : {}
        }
        onClick={() => {
          onTabChange('voice');
        }}>
        {messages.tabs.voice}
      </button>
    </div>
  );
};

export default ChatVoiceTabBar;
